// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rt6ty","text":"styles_text__R8gZH","image":"styles_image__WZg8D","simple":"styles_simple__TF9sE"};